<template>
    <form style="margin-bottom: 22px">
        <div class="row tw-flex">
            <div class="col-xs-20 tw-items-end tw-flex">
                <h2 class="tw-m-0 tw-text-4xl tw-items-end">
                    {{ competition.attributes.name }}
                </h2>
            </div>

            <div class="col-sm-4">
                <select-widget
                    :value="competition.id"
                    :options="competitionOptions"
                    @input="$emit('select', parseInt($event))"
                />
            </div>
        </div>
    </form>
</template>

<script>
import SelectWidget from '@/vendor/forms/FormGroups/Widgets/Select'

export default {
    components: {SelectWidget},

    props: {
        competition: {
            required: true,
            type: Object
        },

        competitions: {
            required: true,
            type: Array
        }
    },

    computed: {
        competitionOptions() {
            return this.competitions.map(competition => ({value: competition.id, label: competition.attributes.name}))
        }
    }
}
</script>
